export const selectLinktrees = (state) =>
  state.linktree.linktrees;

export const selectLinktreesCount = (state) =>
  state.linktree.linktreesCount;

export const selectLinktree = (state) =>
  state.linktree.linktree;

export const selectLinktreeLinks = (state) =>
  state.linktree.linktreeLinks;

export const selectLinktreesOrderBy = (state) =>
  state.linktree.linktreesOrderBy;

export const selectLinktreesFilter = (state) =>
  state.linktree.linktreesFilter;

export const selectLinktreesPagination = (state) =>
  state.linktree.linktreesPagination;
